import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getQueryVariable } from '../common/common';
// @ts-ignore
import i18n from '../language';

// 请求拦截器
axios.interceptors.request.use(
  (config: any) => {
    if (config.method === 'get') {
      config.params = {
        _t: new Date().getTime(),
        ...config.params
      };
    }
    return config;
  }
);
const protocol = location.protocol;
declare var checkInfo: any;
declare var checktext: any;
declare var checkUrl: any;
declare var truthUrl: any;
const reportTypeRelation: any = {
  simple: i18n.t('app.simple'),
  originalText: i18n.t('app.origin'),
  detailPart: i18n.t('app.detail'),
  fullText: i18n.t('app.full'),
  preservation: i18n.t('app.preservation'),
  OneByOne: i18n.t('fOrH.oneReport'),
  simple_ft: i18n.t('app.simple'),
  originalText_ft: i18n.t('app.origin'),
  detailPart_ft: i18n.t('app.detail'),
  fullText_ft: i18n.t('app.full'),
  simple_en: i18n.t('app.simple'),
  originalText_en: i18n.t('app.origin'),
  detailPart_en: i18n.t('app.detail'),
  fullText_en: i18n.t('app.full')
};

// // 响应拦截器
// axios.interceptors.response.use(
//   (response: any): any => {
//     if (response && response.status === 200) {
//       if (response.data.success) {
//         return Promise.resolve(response.data);
//       } else {
//         return Promise.reject(response.data.message);
//       }
//     }
//   },
//   (error: any) => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           window.location.href = error.response.headers.location;
//           break;
//       }
//     }
//   }
// );

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    reportType: 'simple',
    productId: '',
    reportId: '',
    checkInfo: {},
    checkText: '',
    checkUrl: '',
    truthUrl: '',
    checkType: ''
  },
  mutations: {
    changeReportType(states: any, reportType: string) {
      // 设置报告title
      if (states.checkInfo.reportModel && states.checkInfo.reportModel.reportTitle) {
        document.title = states.checkInfo.reportModel.reportTitle + '-' + reportTypeRelation[reportType];
      }
      states.reportType = reportType;
    },
    changeProductId(states: any, productId: string) {
      states.productId = productId;
    },
    changeReportId(states: any, reportId: string) {
      states.reportId = reportId;
    },
    changeCheckInfo(states: any, paramCheckInfo: any) {
      // 设置报告title
      if (paramCheckInfo.reportModel && paramCheckInfo.reportModel.reportTitle) {
        document.title = `${paramCheckInfo.reportModel.reportTitle}-${states.checkType === 'OneByOne' ? reportTypeRelation[states.checkType] : reportTypeRelation[states.reportType]}`
      }
      states.checkInfo = paramCheckInfo;
    },
    changeCheckText(states: any, paramCheckText: string) {
      states.checkText = paramCheckText;
    },
    changeCheckUrl(states: any, paramCheckUrl: string) {
      states.checkUrl = paramCheckUrl;
    },
    changeTruthUrl(states: any, paramTruthUrl: string) {
      states.truthUrl = paramTruthUrl;
    },
    changeCheckType(states: any, checkType: string) {
      states.checkType = checkType;
    },
  },
  actions: {
    setReportType(context: any, reportType: string) {
      context.commit('changeReportType', reportType);
    },
    setCheckType(context: any, checkType: string) {
      context.commit('changeCheckType', checkType);
    },
    setProductId(context: any, productId: string) {
      context.commit('changeProductId', productId);
    },
    setReportId(context: any, reportId: string) {
      context.commit('changeReportId', reportId);
    },
    setCheckInfo(context: any) {
      const search = window.location.search;
      if (protocol === 'file:') {
        context.commit('changeCheckInfo', checkInfo || {});
      } else {
        axios.get(`/api/${getQueryVariable('reportId')}/checkinfo${search}`).then((res: any) => {
          context.commit('changeCheckInfo', res.reportViewModel || {});
        }).catch((e: any) => {
          console.log(e);
        });
      }
    },
    setCheckText(context: any) {
      const search = window.location.search;
      if (protocol === 'file:') {
        context.commit('changeCheckText', checktext || '');
      } else {
        axios.get(`/api/${getQueryVariable('reportId')}/text${search}`).then((res: any) => {

          context.commit('changeCheckText', res.content || '');
        }).catch((e: any) => {
          console.log(e);
        });
      }
    },
    setCheckUrl(context: any, truthLink: string) {
      if (protocol === 'file:') {
        context.commit('changeCheckUrl', checkUrl || '');
        context.commit('changeTruthUrl', truthUrl || '');
      } else {
        axios.get('/api/CheckUrl').then((res: any) => {
          context.commit('changeCheckUrl', res.checkUrl || '');
          // 前端生成真伪链接，区分测试/生产环境
          // context.commit('changeTruthUrl', res.truthUrl || '');
          context.commit('changeTruthUrl', truthLink || '');

        }).catch((e: any) => {
          console.log(e);
        });
      }
    },
  },
  getters: {
    getReportType(states: any) {
      return states.reportType;
    },
    getCheckType(states: any) {
      return states.checkType;
    },
    getProductId(states: any) {
      return states.productId;
    },
    getReportId(states: any) {
      return states.reportId;
    },
    getCheckInfo(states: any) {
      return states.checkInfo;
    },
    getCheckText(states: any) {
      return states.checkText;
    },
    getCheckUrl(states: any) {
      return states.checkUrl;
    },
    getTruthUrl(states: any) {
      return states.truthUrl;
    }
  }
});
